import React, { Suspense, useContext } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { Outlet } from 'react-router';
import WrapperOverlay from './WrapperOverlay';
import HeaderRoutes from '../Header/HeaderRoutes';
import FooterRoutes from '../Footer/FooterRoutes';
import ThemeContext from '../../states/contexts/themeContext';
import PageWrapper from '../PageWrapper/PageWrapper';
import Page from '../Page/Page';
import Card, { CardBody } from '../../components/bootstrap/Card';
import AsideRoutes from '../Aside/AsideRoutes';

export const WrapperContainer = ({ children, className, ...props }) => {
	const { rightPanel } = useContext(ThemeContext);
	return (
		<div
			className={classNames(
				'wrapper',
				{ 'wrapper-right-panel-active': rightPanel },
				className,
			)}
			// eslint-disable-next-line react/jsx-props-no-spreading
			{...props}>
			{children}
		</div>
	);
};
WrapperContainer.propTypes = {
	children: PropTypes.node.isRequired,
	className: PropTypes.string,
};
WrapperContainer.defaultProps = {
	className: null,
};

const Wrapper = () => {
	const _loading = (
		<PageWrapper>
			<Page>
				<div className='row h-100'>
					<div className='col-lg-6'>
						<Card stretch>
							<CardBody>
								<div />
							</CardBody>
						</Card>
					</div>
					<div className='col-lg-6'>
						<Card stretch='semi'>
							<CardBody>
								<div />
							</CardBody>
						</Card>
						<Card stretch='semi'>
							<CardBody>
								<div />
							</CardBody>
						</Card>
					</div>
				</div>
			</Page>
		</PageWrapper>
	);

	return (
		<>
			<AsideRoutes />
			<WrapperContainer>
				<HeaderRoutes />
				<main className='content'>
					<Suspense fallback={_loading}>
						<Outlet />
					</Suspense>
				</main>
				{/* <Content /> */}
				<FooterRoutes />
			</WrapperContainer>
			<WrapperOverlay />
		</>
	);
};

export default Wrapper;
